<template>
  <div
    class="input-field"
    :class="{'error': validationError}"
  >
    <label
      v-if="label"
      :class="required ? 'required' : ''"
    >
      {{ label }}
    </label>

    <input
      ref="inputRef"
      v-model="model"
      :type="type"
      :placeholder="placeholder"
      :pattern="pattern"
      :title="title"
      :required="required"
    >

    <slot />

    <span
      v-if="validationError"
      class="validation-error-message"
    >
      {{ validationError }}
    </span>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue';

const props = defineProps({
  placeholder: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: [Boolean, String],
    default: null,
  },
  type: {
    type: String,
    default: 'text',
  },
  pattern: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: '',
  },
  autofocus: Boolean,
});

const model = defineModel();

const inputRef = ref(null); // It's good practice to initialize refs with null

onMounted(() => {
  // A simple check is often enough within onMounted, but nextTick is safer
  if (props.autofocus && inputRef.value) {
    inputRef.value.focus();
  }
  // Or for maximum safety, especially if the input's rendering depends on other factors:
  autofocusInput();
});

const autofocusInput = async () => {
  if (props.autofocus && inputRef.value) {
    // Using nextTick is the most reliable way to ensure the ref is available
    await nextTick();
    inputRef.value.focus();

    // setTimeout(() => {
    //   inputRef.value.focus();
    // }, 100);
  }
};

</script>

